<div *ngIf="!authUsername && !textError; else elseBlock" class="spinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<ng-template #elseBlock>
  <div class="containerIncidencia">
    <div *ngIf="textError" class="error-message user-error">
      <i-tabler
        name="alert-circle"
        style="color: #d9534f !important"
      ></i-tabler>
      <span>{{ textError }}</span>
    </div>

    <form
      [formGroup]="opIncidentForm"
      *ngIf="authUsername"
      class="containerForm"
    >
      <div class="containerInput">
        <div class="header-row">
          <h1 class="title">Registrar Incidencia</h1>

          <div *ngIf="!selectedService" class="service-action">
            <button
              type="button"
              class="buttonPrimarySolid"
              (click)="openDialogListServices()"
            >
              Escoger Servicio
            </button>
            <span class="service-hint">(Opcional)</span>
          </div>
        </div>

        <div class="badges-row">
          <div class="badge-item">
            <i-tabler name="file" style="color: #4d4d4d !important"></i-tabler>
            <span>Nro. de File: {{ fileNumber }}</span>
          </div>

          <div class="badge-item" *ngIf="selectedService">
            <i-tabler
              name="pinned"
              style="color: #4d4d4d !important"
            ></i-tabler>
            <span>
              Servicio: {{ selectedService.serviceName }}
              <ng-container *ngIf="selectedService?.serviceProviderName"
                >; Proveedor:
                {{ selectedService.serviceProviderName }}</ng-container
              >
            </span>
            <i-tabler
              name="circle-x-filled"
              style="color: #4d4d4d !important; margin-left: 4px"
              (click)="removeService()"
            ></i-tabler>
          </div>
        </div>

        <div class="incidencia">
          <div class="section-header">
            <i-tabler
              name="info-circle"
              style="color: #4e5037 !important"
            ></i-tabler>
            <span>Información de Incidencia</span>
          </div>

          <div class="block">
            <div class="input-block half-width">
              <p class="custom-label">
                Tipo de Incidencia <span class="require">*</span>
              </p>
              <mat-form-field appearance="outline" class="custom-outline">
                <mat-select
                  formControlName="opIncidentType"
                  placeholder="Selecciona la Incidencia"
                >
                  <mat-option
                    *ngFor="let opIncidentType of opIncidentTypes"
                    [value]="opIncidentType"
                  >
                    {{ opIncidentType }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    opIncidentForm.get('opIncidentType')?.hasError('required')
                  "
                >
                  Requerido.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="input-block half-width">
              <p class="custom-label">Estado <span class="require">*</span></p>
              <mat-form-field appearance="outline" class="custom-outline">
                <mat-select
                  formControlName="incidentStatus"
                  placeholder="Selecciona el Estado"
                >
                  <mat-option
                    *ngFor="let status of incidentStatus"
                    [value]="status"
                  >
                    {{ renameOpIncidentStatus(status) | titlecase }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                    opIncidentForm.get('incidentStatus')?.hasError('required')
                  "
                >
                  Requerido.
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="input-block full-width">
            <p class="custom-label">
              Descripción de Incidencia <span class="require">*</span>
            </p>
            <mat-form-field
              appearance="outline"
              class="custom-outline text-area-field"
            >
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="4"
                cdkAutosizeMaxRows="8"
                formControlName="description"
                name="descripcion"
              ></textarea>
              <mat-error
                *ngIf="opIncidentForm.get('description')?.hasError('required')"
              >
                Requerido.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="section-header">
            <i-tabler
              name="info-circle"
              style="color: #4e5037 !important"
            ></i-tabler>
            <span>Información de Resolución de Incidencia</span>
          </div>

          <div class="block">
            <div class="input-block half-width">
              <p class="custom-label">Fecha de Solución</p>
              <mat-form-field appearance="outline" class="custom-outline">
                <input
                  type="date"
                  matInput
                  formControlName="solutionDate"
                  name="solutionDate"
                />
              </mat-form-field>
            </div>

            <div class="input-block half-width">
              <p class="custom-label">Tiempo de Solución</p>
              <div class="time-solution-group">
                <mat-form-field
                  appearance="outline"
                  class="custom-outline time-input"
                >
                  <input
                    type="number"
                    matInput
                    formControlName="solutionTime"
                    name="solutionTime"
                    placeholder="Hora(s) o Día(s)"
                  />
                </mat-form-field>
                <mat-form-field
                  appearance="outline"
                  class="custom-outline time-select"
                >
                  <mat-select formControlName="solutionTimeUnit">
                    <mat-option value="Hora(s)">Hora(s)</mat-option>
                    <mat-option value="Día(s)">Día(s)</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="input-block full-width">
            <p class="custom-label">Descripción de Acciones Realizadas</p>
            <mat-form-field
              appearance="outline"
              class="custom-outline text-area-field"
            >
              <textarea
                matInput
                cdkTextareaAutosize
                cdkAutosizeMinRows="4"
                cdkAutosizeMaxRows="8"
                formControlName="actions"
                name="acciones"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
    <div class="containerButtons">
      <button class="buttonSecondaryOutline" (click)="closeDialog()">
        Cancelar
      </button>
      <button
        *ngIf="authUsername"
        class="buttonPrimarySolid"
        (click)="addOpIncident()"
        [disabled]="opIncidentForm.invalid || isSubmitting"
      >
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
          "
        >
          <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
          <span>Agregar</span>
        </div>
      </button>
    </div>
  </div>
</ng-template>
